
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SuperAdminDashboard from '@/pages/SuperAdminDashboard';
import SuperAdminSettings from '@/pages/SuperAdminSettings';
import SuperAdminProfile from '@/pages/SuperAdminProfile';
import SuperAdminInstances from '@/pages/SuperAdminInstances';
import SuperAdminResellerPlans from '@/pages/SuperAdminResellerPlans';
import SuperAdminInstance from '@/pages/SuperAdminInstance';
import SuperAdminInstancePayments from '@/pages/SuperAdminInstancePayments';
import SuperAdminInstanceReferralIds from '@/pages/SuperAdminInstanceReferralIds';
import SuperAdminReferralBank from '@/pages/SuperAdminReferralBank';
import SuperAdminBusinessSetup from '@/pages/SuperAdminBusinessSetup';
import SuperAdminSupportManagement from '@/pages/SuperAdminSupportManagement';
import SuperAdminKnowledgeBase from '@/pages/SuperAdminKnowledgeBase';
import SuperAdminSubscriptions from '@/pages/SuperAdminSubscriptions';
import SuperAdminRewardSales from '@/pages/SuperAdminRewardSales';
import { useSuperAdminSettings } from '@/hooks/useSuperAdminSettings';
import { Toaster } from '@/components/ui/toaster';
import { MasterLicenseSettingsProvider } from '@/contexts/MasterLicenseSettingsContext';

// Create placeholders for missing pages
const SuperAdminPendingOrders = () => {
  return (
    <div className="container mx-auto py-6 px-4">
      <h1 className="text-2xl font-bold mb-6">Pending Orders</h1>
      <p>This page is under construction.</p>
    </div>
  );
};

interface SuperAdminRoutesProps {
  isLoggedIn?: boolean;
  userRole?: string | null;
}

const SuperAdminRoutes: React.FC<SuperAdminRoutesProps> = ({ isLoggedIn, userRole }) => {
  const { isLoading } = useSuperAdminSettings();

  // Show loading state for all super admin routes
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <MasterLicenseSettingsProvider isLoading={isLoading}>
      <Toaster />
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<SuperAdminDashboard />} />
        <Route path="instances" element={<SuperAdminInstances />} />
        <Route path="instance/:id" element={<SuperAdminInstance />} />
        <Route path="instance/:id/payments" element={<SuperAdminInstancePayments />} />
        <Route path="instance/:id/referral-ids" element={<SuperAdminInstanceReferralIds />} />
        <Route path="referral-bank" element={<SuperAdminReferralBank />} />
        <Route path="business-setup" element={<SuperAdminBusinessSetup />} />
        <Route path="support" element={<SuperAdminSupportManagement />} />
        <Route path="knowledge-base" element={<SuperAdminKnowledgeBase />} />
        <Route path="settings" element={<SuperAdminSettings />} />
        <Route path="profile" element={<SuperAdminProfile />} />
        <Route path="reseller-plans" element={<SuperAdminResellerPlans />} />
        <Route path="subscriptions" element={<SuperAdminSubscriptions />} />
        <Route path="pending-orders" element={<SuperAdminPendingOrders />} />
        <Route path="reward-sales" element={<SuperAdminRewardSales />} />
        
        {/* Catch-all route to avoid blank pages */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </MasterLicenseSettingsProvider>
  );
};

export default SuperAdminRoutes;
